import { ConsommationFlotteList } from '@services/interfaces/generated/YSER-v1';
import { DecimalTransform } from '@shared/constants';
import GraphExporter from '@shared/components/graph-exporter';
import { transformUnit } from '@shared/misc/helpers/data';
import { capitalizeFirstLetter } from '@shared/misc/helpers/strings';
import moment from 'moment';
import 'moment/locale/fr';
import { useMemo } from 'react';

type FlotteExportWrapperProps = {
  data: ConsommationFlotteList | undefined;
  unitLabelCO2: string;
  unitLabelData: string;
  unitIndexCO2: number;
  unitIndexData: number;
};

const FlotteExportWrapper = ({
  data,
  unitLabelCO2,
  unitLabelData,
  unitIndexCO2,
  unitIndexData,
}: FlotteExportWrapperProps): React.ReactElement => {
  const exportData = useMemo(() => {
    if (!data?.items) return [];

    return data.items.map((item) => {
      const dateToFormat = new Date(item.date);
      const fullDate = moment(dateToFormat).format('MMMM\xa0YYYY');

      const co2Value = transformUnit(item.co2eq, 'co2eq', unitIndexCO2, DecimalTransform.Export);
      const dataValue = transformUnit(item.data, 'data', unitIndexData, DecimalTransform.Export);

      return {
        consoDataGraphDate: capitalizeFirstLetter(fullDate),
        consoDataGraphValue: co2Value.value,
        valueData: dataValue.value,
      };
    });
  }, [data?.items, unitIndexCO2, unitIndexData]);

  const headers = [
    { label: 'Date', key: 'consoDataGraphDate' },
    { label: unitLabelCO2, key: 'consoDataGraphValue' },
    { label: unitLabelData, key: 'valueData' },
  ];

  return <GraphExporter data={exportData} headers={headers} exportType="flotte" />;
};

export default FlotteExportWrapper;
